import React from 'react';
import { Box, Typography, Grid, Container, useTheme } from '@mui/material';
import {
    Search as SearchIcon,
    LibraryBooks as LibraryBooksIcon,
    Bookmark as BookmarkIcon,
    CloudDownload as CloudDownloadIcon,
    Image as ImageIcon,
    Edit as EditIcon
} from '@mui/icons-material';


// Define the feature data in an array for better configurability
const features = [
    {
        icon: <SearchIcon sx={{ fontSize: '3rem', color: "primary.dark" }} />,
        title: "Ask Anything",
        description: "Use AI to instantly clarify any concept. Ask questions and get precise answers in seconds."
    },
    {
        icon: <LibraryBooksIcon sx={{ fontSize: '3rem', color: "primary.dark" }} />,
        title: "Create Notes",
        description: "Organize your thoughts and keep track of key concepts. Make notes that are always accessible."
    },
    {
        icon: <BookmarkIcon sx={{ fontSize: '3rem', color: "primary.dark" }} />,
        title: "Bookmark Content",
        description: "Save and easily access important content or insights for future reference."
    },
    {
        icon: <CloudDownloadIcon sx={{ fontSize: '3rem', color: "primary.dark" }} />,
        title: "Generate PDFs",
        description: "Convert your valuable notes and generated content into downloadable PDFs."
    },
    {
        icon: <ImageIcon sx={{ fontSize: '3rem', color: "primary.dark" }} />,
        title: "Upload Image",
        description: "Upload your images for easier use and faster extraction within the app."
    },
    {
        icon: <EditIcon sx={{ fontSize: '3rem', color: "primary.dark" }} />,
        title: 'Real-Time Editing',
        description: 'Edit AI-generated content in real-time and create images or PDFs with ease.',
    }

];

const Features = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: 'grey.A100',
                padding: theme.spacing(8, 2),
                textAlign: 'center',
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                        marginBottom: theme.spacing(4),
                    }}
                >
                    Features That Empower Your Learning
                </Typography>

                <Box sx={{ margin: '0 auto' }}>
                    <Grid container spacing={6} justifyContent="center" alignItems="stretch">
                        {features.map((feature, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Box
                                    sx={{
                                        padding: theme.spacing(3),
                                        backgroundColor: 'background.default',
                                        borderRadius: '12px',
                                        boxShadow: 3,
                                        textAlign: 'center',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        height: '100%',
                                        transition: 'all 0.3s ease', // Smooth transition
                                        '&:hover': {
                                            transform: 'scale(1.05)', // Slight scale effect on hover
                                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', // Soft shadow on hover
                                        },
                                    }}
                                >
                                    {feature.icon}
                                    <Typography variant="h6" sx={{ marginTop: theme.spacing(2), fontWeight: 600 }}>
                                        {feature.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ marginTop: theme.spacing(1) }}>
                                        {feature.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>


            </Container>
        </Box>
    );
};

export default Features;
